import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import * as actions from '../actions';
import PropTypes from 'prop-types';
import SideBarMenu from './SideBarMenu';
import PrevNext from './PrevNext';

/**
* Import components
*/
import StepOne from './wt-steps/StepOne';
import StepTwo from './wt-steps/StepTwo';
import StepThree from './wt-steps/StepThree';
import StepFour from './wt-steps/StepFour';
import Download from './download/Download';

import wtImage from '../assets/images/wt_5.png';

class WT extends Component {

    componentDidMount() {
        const breadCrumbSecond = `${this.props.translate('BREADCRUMBS.sortiment')} ${this.props.translate('BREADCRUMBS.wt')}`;
        const breadCrumbThird = this.props.translate('BREADCRUMBS.model');
        this.props.setBreadCrumbs(breadCrumbSecond, breadCrumbThird);
        // set articleID
        this.props.setArticle(this.props.articleID);
    }

    componentDidUpdate() { }

    /**
    * render relevant component for each step
    * @param step
    * @returns {XML}
    */
    renderStep(step, lastStep) {
        switch (step) {

            case 1:
                return <StepOne articleID={this.props.articleID} lastStep={lastStep} />;
            case 2:
                return <StepTwo articleID={this.props.articleID} lastStep={lastStep} />;
            case 3:
                return <StepThree articleID={this.props.articleID} lastStep={lastStep} />;
            case 4:
                return <StepFour  articleID={this.props.articleID} lastStep={lastStep} />;
            case 5:
                return <Download articleID={this.props.articleID} article='wt' image={wtImage} name='configured image' currentStep={step} lastStep={step} />;
            default:
                return <StepOne lastStep={lastStep} />;

        }
    }
    render() {

        const breadCrumbSecond = `${this.props.translate('BREADCRUMBS.sortiment')} ${this.props.translate('BREADCRUMBS.wt')}`;
        this.props.setBreadCrumbs(breadCrumbSecond);

        return (
            <div className='row configurator-container'>
                <div className='col s12 m3 div-menu-col'>
                    <div className='div-menu'>
                        <div className='vertical-line'></div>
                        <div className='above-first-step'></div>
                        <SideBarMenu
                            stepList={['One', 'Two', 'Three', 'Four', 'Five']}
                            field='WT'
                            lastStep={5} />
                        <div className='below-last-step'></div>
                    </div>
                </div>
                <div className='col s12 m9 step-col'>
                    <div className='step-container'>
                        {this.renderStep(this.props.step, 5)}
                        <PrevNext divClass='col s12' currentStep={this.props.step} lastStep={5} />
                    </div>
                </div>
            </div>
        );
    }

}

WT.propTypes = {
    step:      PropTypes.number,
    translate: PropTypes.func,
}

function mapStateToProps(state) {
    return {
        translate: getTranslate(state.locale),
        step:      state.steps.currentStep,
    }
}

export default connect(mapStateToProps, actions)(WT);



// WEBPACK FOOTER //
// ./src/components/WT.js